import { contains, map, prop } from 'ramda';

import { getSplashScreen } from '../selectors/settings';
import { isNotNillNorEmpty } from './helpers';

export const hasSplashScreen = state => getSplashScreen(state);

export const getPhoneCountryPreferences = (settings, local) => {
  const preferredCountries = map(prop('iso2'), settings.ELIGIBILITYCHECK_PHONE_NUMBER_FORMATS || []);
  const hasPreferredCountries = isNotNillNorEmpty(preferredCountries);

  const defaultPhoneCountry =
    hasPreferredCountries && contains({ iso2: local }, settings.ELIGIBILITYCHECK_PHONE_NUMBER_FORMATS)
      ? local
      : settings.ELIGIBILITYCHECK_DEFAULT_REGION.toLowerCase();

  return { preferredCountries, defaultPhoneCountry };
};
